import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import { Campaign } from '../../../model/campaign/Campaign';
import { Pagination } from '../../../shared/components/Pagination';
import TableSkeleton, { ITableColumn } from '../../../shared/components/TableSkeleton';
import { CampaignsService } from '../CampaignsService';
import { formatDate } from '../../../utils/Functions';
import { ErrorToast } from '../../../utils/toasters';

const EMAILING_COLUMNS: ITableColumn[] = [
    { label: 'ID' },
    { label: 'Title' },
    { label: 'Apply until' },
    { label: 'Email sent' },
    { label: 'Status' },
    { label: 'Action', className: 'text-end' },
];

export function CampaignEmailing() {
    const navigate = useNavigate();
    const [state, setState] = useState({
        page: 1,
        perPage: 15,
        title: '',
        status: 'published',
        approvalStatus: 'approved',
    });

    const [campaign, setCampaign] = useState<Campaign[]>([]);
    const [change, setChange] = useState(false);
    const [totalPages, setTotalPages] = useState(0);
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        setDataLoading(true);
        CampaignsService.getCampaigns(state)
            .then(data => {
                setCampaign(data.data);
                setTotalPages(Math.ceil(data.count / state.perPage));
            })
            .catch(err => ErrorToast(err))
            .finally(() => setDataLoading(false));
    }, [change]);

    function handleClick() {
        setChange(!change);
        setState({
            ...state,
            page: 1,
        });
    }

    function handleChange(evt: any) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value,
        });
    }

    const handlePages = (updatePage: number) => {
        setState({ ...state, page: updatePage });
        setChange(!change);
    };

    return (
        <>
            <div
                className="card mb-5 p-4 mt-3"
                onKeyDown={e => {
                    if (e.key === 'Enter') handleClick();
                }}
            >
                <Row>
                    <Form.Group as={Col} className="col-4 mb-0">
                        <Form.Control
                            placeholder="Title or Campaign ID"
                            className="autocomplete-input"
                            name="title"
                            onChange={handleChange}
                        />
                    </Form.Group>
                    <Form.Group as={Col} className="mb-0">
                        <Button type="submit" onClick={() => handleClick()}>
                            Search
                        </Button>
                    </Form.Group>
                </Row>
            </div>

            <div className="card mb-5 p-4 table-responsive">
                {dataLoading ? (
                    <TableSkeleton columns={EMAILING_COLUMNS} rows={state.perPage} />
                ) : (
                    <Table hover>
                        <thead>
                            <tr>
                                {EMAILING_COLUMNS.map(column => (
                                    <th key={column.label} className={column.className}>
                                        {column.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {campaign?.map(e => (
                                <tr key={e.id}>
                                    <td>{e.id}</td>
                                    <td>{e.title}</td>
                                    <td>{formatDate(e.date)}</td>
                                    <td>
                                        <span
                                            className={`status ${
                                                e.isInfluencersNotificationSent ? 'accepted' : 'declined'
                                            }`}
                                        >
                                            {e.isInfluencersNotificationSent ? 'Email sent' : 'Not sent'}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`status ${e?.status}`}>
                                            {e?.status === 'published' ? 'public' : e.status}
                                        </span>
                                    </td>
                                    <td>
                                        <Button
                                            onClick={() =>
                                                navigate(`/campaign/emailing/preview`, {
                                                    state: {
                                                        id: e.id,
                                                        sendEmail: e.isInfluencersNotificationSent,
                                                        sentLanguages: e.sentLanguages,
                                                    },
                                                })
                                            }
                                        >
                                            Send email
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}

                <Pagination
                    page={state.page}
                    totalPages={totalPages}
                    handlePagination={handlePages}
                    disabled={dataLoading}
                />
            </div>
        </>
    );
}
